import { PaymentMethod } from '@/app/enums';
import { useRouter } from 'next/navigation';

export const useRedirectToDonationDetail = () => {
  const router = useRouter();

  const redirectToDonationDetail = ({ id, paymentMethod }: { id: string; paymentMethod: PaymentMethod }) => {
    const queryString = paymentMethod === PaymentMethod.Card ? '?redirectToGateway=1' : '';

    const baseUrl = process.env.NEXT_PUBLIC_REDIRECT_URL;

    if (baseUrl?.endsWith('/')) {
      return router.push(`${baseUrl}prispevek/detail/${id}${queryString}`);
    }

    router.push(`${baseUrl}/prispevek/detail/${id}${queryString}`);
  };

  return redirectToDonationDetail;
};
